import { FC } from 'react';

import { CheckIconXl } from '@lichtblick/icons/svg/check/check-xl';
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Headline } from '@lichtblick/photon/atoms/headline/headline';
import { Text } from '@lichtblick/photon/atoms/text/text';

import styles from './Confirmation.module.scss';
import formStyles from './Form.module.scss';

type ConfirmationProps = {
  email: string;
  onBackButtonClick: () => void;
};

export const Confirmation: FC<ConfirmationProps> = ({ email, onBackButtonClick }) => (
  <section className={styles.container} ref={(ref) => ref?.scrollIntoView({ block: 'center', behavior: 'smooth' })}>
    <Headline className={formStyles.headline} renderAs="h2" size="m">
      Gute Idee! Für Ihr Unter&shy;nehmen und das Klima
      <CheckIconXl className={styles['check-icon']} />
    </Headline>
    <Text>
      Danke für die Anfrage. Zur Sicherheit kommt gleich eine E-Mail von LichtBlick an <em>{email}</em>. Die bitte
      einmal bestätigen und dann meldet sich bald ein*e LichtBlick-Berater*in.
    </Text>
    <BoxCTA
      as="button"
      className={styles['back-button']}
      onClick={onBackButtonClick}
      type="button"
      variant="neutral-outline"
    >
      Nochmal zurück
    </BoxCTA>
  </section>
);
